<template>

</template>

<script>

export default {
  name: "Redirect",

  created(){
    window.location.href = "http://bit.ly/4kvKdG0";
  },
};
</script>
